// frontend/src/utils/formatRelativeTime.js
import { localizedValue } from '../localization/presentationLanguage';

export function formatRelativeTime(whenMs) {
  if (!whenMs) return "";
  const diff = Date.now() - Number(whenMs);
  if (diff < 0) return localizedValue({ es: 'ahora', en: 'now' });
  const s = Math.floor(diff / 1000);
  if (s < 60) return localizedValue({ es: 'hace unos segundos', en: 'a few seconds ago' });
  const m = Math.floor(s / 60);
  if (m < 60) return localizedValue({ es: `hace ${m} min`, en: `${m} min ago` });
  const h = Math.floor(m / 60);
  if (h < 24) return localizedValue({ es: `hace ${h} h`, en: `${h} hr ago` });
  const d = Math.floor(h / 24);
  if (d < 7) return localizedValue({ es: `hace ${d} d`, en: `${d} days ago` });
  const w = Math.floor(d / 7);
  if (w < 5) return localizedValue({ es: `hace ${w} sem`, en: `${w} weeks ago` });
  const mo = Math.floor(d / 30);
  if (mo < 12) return localizedValue({ es: `hace ${mo} mes`, en: `${mo} months ago` });
  const y = Math.floor(d / 365);
  return localizedValue({ es: `hace ${y} año${y > 1 ? 's' : ''}`, en: `${y} year${y === 1 ? '' : 's'} ago` });
}
